<template>
  <div
    :class="{
      'unselectable-text':
        (user && user.group_names.includes('ESTUDIANTES')) ||
        preview_evaluation,
    }"
  >
    <div v-if="isLoading">
      <b-card>
        <b-skeleton animation width="85%"></b-skeleton>
        <b-skeleton animation width="55%"></b-skeleton>
        <b-skeleton animation width="70%"></b-skeleton>
      </b-card>
    </div>
    <div v-else class="question-container">
      <div
        v-if="allows_crud"
        class="question-move px-1 handle"
        :class="{ 'grabbable-cursor': allows_crud }"
      >
        <b-icon class="move-icon" icon="arrows-expand" scale="1.3"></b-icon>
      </div>

      <div class="container-content-question">
        <!-- Container Header -->
        <div class="container-header">
          <div class="container-body-card">
            <div class="question-body max-width-print max-width d-flex">
              <div class="row-div">
                <strong>
                  <span v-if="testSegment">{{ displayedSegmentOrder }}.</span
                  >{{ Question.order }}
                </strong>
              </div>
              <div
                class="w-100"
                :class="{
                  'title-container': allows_crud && !Question.is_locked,
                }"
                @click="showModalQuestion()"
              >
                <RenderVHtml
                  class="p-0"
                  v-b-tooltip.top.noninteractive.v-secondary="
                    `${
                      allows_crud && !Question.is_locked
                        ? $t('evaluations.newEvaluations.editEntity', {
                            entity: $getVisibleNames(
                              'manual.test.enunciado',
                              false,
                              'Enunciado'
                            ),
                          })
                        : ''
                    }`
                  "
                  :content="Question.title"
                ></RenderVHtml>
              </div>
            </div>
            <div
              :class="{
                'container-buttons-allow-cruds':
                  allows_crud || test.manual_is_valid,
              }"
            >
              <InfoPopover
                v-if="
                  allows_crud &&
                  !Question.is_locked &&
                  institution &&
                  institution.internal_use_id != 'duoc.cl'
                "
                :id_popover="`header-criteria-micro-${Question.id}`"
                :variant="
                  Question.evaluation_criterias_micro.length == 0
                    ? `warning`
                    : `info`
                "
                :custom_class="`h2 icon-info-tooltip`"
                :icon="
                  Question.evaluation_criterias_micro.length == 0
                    ? `exclamation-square-fill`
                    : 'info-square-fill'
                "
                class="ml-1 mr-1"
              >
                <template #title>
                  <div>
                    {{ $t("evaluations.newEvaluations.achievementIndicators") }}
                  </div>
                </template>
                <!-- body -->
                <template>
                  <div v-if="Question.evaluation_criterias_micro.length == 0">
                    {{ $t("evaluations.newEvaluations.noAssociatedIndicator") }}
                  </div>
                  <div v-else class="visible_columns">
                    <div v-if="Question.evaluation_criterias_micro.length == 1">
                      {{
                        $t(
                          "evaluations.newEvaluations.indicatorAssociatedToQuestion"
                        )
                      }}:
                    </div>
                    <div v-if="Question.evaluation_criterias_micro.length > 1">
                      {{
                        $t(
                          "evaluations.newEvaluations.indicatorsAssociatedToQuestion"
                        )
                      }}:
                    </div>
                    <div
                      v-for="evaluation_criteria in evalutionCriteriaMicro"
                      :key="`b-popover-body-${evaluation_criteria.id}`"
                      class="align-middle"
                    >
                      - {{ evaluation_criteria.full_sentence }}
                    </div>
                  </div>
                </template>
              </InfoPopover>
              <ButtonMedium
                v-if="
                  (!Question.is_locked &&
                    allows_crud &&
                    user &&
                    !user.group_names.includes('PROFESORES')) ||
                  (test.manual_is_valid &&
                    !Question.is_locked &&
                    !preview_evaluation &&
                    user &&
                    !user.group_names.includes('PROFESORES'))
                "
                tabindex="-1"
                :tooltip_text="
                  test.manual_is_valid
                    ? $t('evaluations.newEvaluations.questionUnlockedAndClosed')
                    : $t('evaluations.newEvaluations.lockQuestion')
                "
                :text_button="``"
                :click_button="changeStateQuestion"
                :icon="'unlock'"
                :variant="'primary'"
                :custom_class="`mr-1`"
                :disabled_button="test.manual_is_valid"
              >
              </ButtonMedium>
              <ButtonMedium
                v-if="
                  (Question.is_locked &&
                    allows_crud &&
                    user &&
                    !user.group_names.includes('PROFESORES')) ||
                  (test.manual_is_valid &&
                    Question.is_locked &&
                    !preview_evaluation &&
                    user &&
                    !user.group_names.includes('PROFESORES'))
                "
                tabindex="-1"
                :tooltip_text="
                  test.manual_is_valid
                    ? $t('evaluations.newEvaluations.questionLockedAndClosed')
                    : $t('evaluations.newEvaluations.unlockQuestion')
                "
                :text_button="``"
                :click_button="changeStateQuestion"
                :icon="'lock'"
                :variant="'primary'"
                :custom_class="`mr-1`"
                :disabled_button="test.manual_is_valid"
              >
              </ButtonMedium>
              <ButtonMedium
                v-if="allows_crud && !Question.is_locked"
                tabindex="-1"
                :tooltip_text="$t('evaluations.newEvaluations.editQuestion')"
                :text_button="``"
                :click_button="openModalQuestion"
                :icon="'square'"
                :variant="'primary'"
                :custom_class="`mr-1`"
              >
              </ButtonMedium>
              <!-- Copiar Pregunta -->
              <template v-if="!copy_button_tem_check">
                <ButtonMedium
                  v-if="allows_crud && !Question.is_locked"
                  tabindex="-1"
                  :tooltip_text="
                    $t('evaluations.newEvaluations.duplicateQuestion')
                  "
                  :text_button="``"
                  :click_button="copyQuestion"
                  :icon="'files'"
                  :variant="'primary'"
                  :custom_class="`mr-1`"
                >
                </ButtonMedium>
              </template>
              <template v-else>
                <ButtonMedium
                  :tooltip_text="``"
                  :text_button="``"
                  :icon="'files'"
                  :variant="'secondary'"
                  :custom_class="`mr-1`"
                  :disabled_button="true"
                >
                </ButtonMedium>
              </template>
              <ButtonMedium
                v-if="allows_crud && !Question.is_locked"
                tabindex="-1"
                :tooltip_text="$t('evaluations.newEvaluations.deleteQuestion')"
                :text_button="``"
                :click_button="askForDeleteQuestion"
                :icon="'trash'"
                :variant="'danger'"
                :custom_class="`mr-1`"
              >
              </ButtonMedium>
            </div>
          </div>
        </div>

        <!-- Container Body -->
        <div class="container-body">
          <div
            v-if="institution && institution.internal_use_id != 'duoc.cl'"
            class="description-question"
            :class="{
              'description-container': allows_crud && !Question.is_locked,
              'unselectable-text':
                (user && user.group_names.includes('ESTUDIANTES')) ||
                preview_evaluation,
            }"
            @click="showModalDescriptionQuestion()"
          >
            <RenderVHtml
              v-b-tooltip.top.noninteractive.v-secondary="
                `${
                  allows_crud && !Question.is_locked
                    ? $t('evaluations.newEvaluations.editDescription')
                    : ''
                }`
              "
              :content="Question.description"
            ></RenderVHtml>
          </div>
          <div class="separator mb-2 mt-1"></div>

          <div class="limit-words-section" v-if="Question.question_type == 1">
            <LimitQuestion
              :Question="Question"
              :QuestionScore="EvaluateeQuestionScore"
              :allows_crud="allows_crud && !Question.is_locked"
              :preview_evaluation="preview_evaluation"
              :evaluatee_view="evaluatee_view"
              :evaluator_view="evaluator_view"
              :is_running_test="is_running_test"
              :finished_test="finished_test"
              :user_id="user_id"
            ></LimitQuestion>
          </div>

          <div v-else-if="Question.question_type == 2">
            <SelectQuestionOptions
              class="ml-3"
              :Question="Question"
              :QuestionScore="EvaluateeQuestionScore"
              :allows_crud="allows_crud && !Question.is_locked"
              :preview_evaluation="preview_evaluation"
              :evaluatee_view="evaluatee_view"
              :evaluator_view="evaluator_view"
              :is_running_test="is_running_test"
              :finished_test="finished_test"
              :user_id="user_id"
              :is_published="is_published"
              :test="test"
            >
            </SelectQuestionOptions>
          </div>
          <div v-else-if="Question.question_type == 3">
            <FillingQuestion
              :Question="Question"
              :allows_crud="allows_crud && !Question.is_locked"
              :preview_evaluation="preview_evaluation"
              :evaluatee_view="evaluatee_view"
              :evaluator_view="evaluator_view"
              :is_running_test="is_running_test"
              :finished_test="finished_test"
            >
            </FillingQuestion>
          </div>
          <div v-else-if="Question.question_type == 4">
            <MatchingQuestion
              :Question="Question"
              :container_instrument_id="container_instrument_id"
              :QuestionScore="EvaluateeQuestionScore"
              :allows_crud="allows_crud && !Question.is_locked"
              :preview_evaluation="preview_evaluation"
              :evaluatee_view="evaluatee_view"
              :evaluator_view="evaluator_view"
              :is_running_test="is_running_test"
              :finished_test="finished_test"
              :user_id="user_id"
            >
            </MatchingQuestion>
          </div>
          <div
            v-if="
              evaluator_view &&
              user_id &&
              Question.linked_rubric_criteria != null
            "
          >
            <RubricsContainer
              class="ml-4 mr-4"
              :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
              :container_instrument_id="container_instrument_id"
              :instrument_id="Question.test"
              :allows_crud="false"
              :preview_evaluation="preview_evaluation"
              :evaluator_view="evaluator_view"
              :user_id="user_id"
              :closedEvaluationScore="closedEvaluationScore"
              :requests_within_the_component="false"
              :filter_rubric_instance="Question.linked_rubric_criteria"
            ></RubricsContainer>
          </div>
          <div
            class="separator mb-3"
            :class="{ 'mt-2': Question.question_type == 2 }"
          ></div>
        </div>
        <!-- Container Footer -->
        <div>
          <div class="container-footer">
            <div class="d-flex">
              <div class="score-input-container" v-if="!checked_score">
                <div class="mr-1">
                  <strong>{{ $t("evaluations.newEvaluations.score") }}:</strong>
                </div>
                <b-form-input
                  v-if="allows_crud && !Question.is_locked"
                  class="mr-3"
                  :class="{
                    'score-input-warning': questionsMaxScore > test.max_score,
                    'score-input-warning-minor':
                      questionsMaxScore < test.max_score,
                  }"
                  v-b-tooltip.top.noninteractive.v-danger="
                    `${
                      questionsMaxScore > test.max_score
                        ? $t(
                            'evaluations.newEvaluations.scoreGreaterThanInstrument',
                            {
                              entity: $getVisibleNames(
                                'evaluations2.test',
                                false,
                                'Instrumento',
                                true
                              ),
                            }
                          )
                        : questionsMaxScore < test.max_score
                        ? $t(
                            'evaluations.newEvaluations.scoreLessThanInstrument',
                            {
                              entity: $getVisibleNames(
                                'evaluations2.test',
                                false,
                                'Instrumento',
                                true
                              ),
                            }
                          )
                        : ''
                    }`
                  "
                  v-model="Question.max_score"
                  @input="patchQuestionScore"
                  type="number"
                  min="0"
                ></b-form-input>
                <div v-else class="mr-2">{{ Question.max_score }}</div>
              </div>
              <div class="d-flex mr-2" v-if="!checked_weightning">
                <strong class="mr-2"
                  >{{ $t("evaluations.newEvaluations.weighting") }}:</strong
                >
                <div
                  v-if="
                    institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    Question.linked_rubric_criteria != null &&
                    rubricsCriteria &&
                    allows_crud
                  "
                  :class="{
                    'text-danger':
                      questionsWeighingRubricCriteria !=
                      rubricsCriteria.weighing,
                  }"
                  v-b-tooltip.top.noninteractive.v-info="
                    `${
                      questionsWeighingRubricCriteria > rubricsCriteria.weighing
                        ? $t('evaluations.newEvaluations.exceededWeighting', {
                            weighing: rubricsCriteria.weighing,
                            score: suggestedScore * -1,
                          })
                        : questionsWeighingRubricCriteria <
                          rubricsCriteria.weighing
                        ? $t('evaluations.newEvaluations.availableWeighting', {
                            weighing: parseFloat(
                              (
                                rubricsCriteria.weighing -
                                questionsWeighingRubricCriteria
                              ).toFixed(2)
                            ),
                            score: suggestedScore,
                          })
                        : ''
                    }`
                  "
                >
                  {{ questionsWeighing }}%
                </div>
                <div v-else>{{ questionsWeighing }}%</div>
              </div>
              <div class="question-type-container">
                <div class="question-type mr-2">
                  <strong>
                    {{ $t("evaluations.newEvaluations.questionType") }}:</strong
                  >
                </div>
                <div
                  :class="{
                    'text-danger':
                      (!enable_question_types.includes(
                        Question.question_type
                      ) ||
                        (Question.question_type == 2 &&
                          !enable_question_sub_types.includes(
                            Question.subtype
                          ))) &&
                      allows_crud,
                  }"
                  v-b-tooltip.top.noninteractive.v-danger="
                    `${
                      (!enable_question_types.includes(
                        Question.question_type
                      ) ||
                        (Question.question_type == 2 &&
                          !enable_question_sub_types.includes(
                            Question.subtype
                          ))) &&
                      allows_crud
                        ? $t(
                            'evaluations.newEvaluations.questionTypeNotBelongToSituation',
                            {
                              entity: $getVisibleNames(
                                'teaching.evaluationsituation',
                                false,
                                'Situación Evaluativa'
                              ),
                            }
                          )
                        : ''
                    }`
                  "
                >
                  {{ questionTypes() }}
                  <template v-if="Question.question_type == 2">
                    <span v-if="Question.subtype == 2">
                      {{ $t("evaluations.newEvaluations.multiple") }}</span
                    >
                    <span v-else-if="Question.subtype == 1">
                      {{ $t("evaluations.newEvaluations.simple") }}</span
                    >
                  </template>
                </div>
              </div>
            </div>
            <div v-if="evaluatee_view && Question" class="mr-2">
              <b-icon
                v-if="
                  (!EvaluateeQuestionScore && Question.question_type == 1) ||
                  (EvaluateeQuestionScore &&
                    EvaluateeQuestionScore.answer == '' &&
                    Question.question_type == 1) ||
                  (Question.question_type == 2 &&
                    evaluateeMultipleChoiceQuestionOptions.length == 0) ||
                  (Question.question_type == 4 &&
                    EvaluateeQuestionUnitScores.length == 0)
                "
                icon="x-circle"
                variant="danger"
                scale="1.3"
                v-b-tooltip.top.noninteractive.v-danger="
                  $t('evaluations.newEvaluations.questionNotSaved')
                "
              ></b-icon>
              <b-icon
                v-if="
                  (EvaluateeQuestionScore &&
                    EvaluateeQuestionScore.answer != '' &&
                    Question.question_type == 1) ||
                  (Question.question_type == 2 &&
                    evaluateeMultipleChoiceQuestionOptions.length > 0) ||
                  (Question.question_type == 4 &&
                    EvaluateeQuestionUnitScores.length > 0)
                "
                icon="check-circle"
                variant="success"
                scale="1.3"
                v-b-tooltip.top.noninteractive.v-success="
                  $t('evaluations.newEvaluations.questionSaved')
                "
              ></b-icon>
            </div>
            <template v-if="evaluator_view && user_id">
              <div class="d-flex">
                <div
                  v-if="
                    Question.question_type == 2 || Question.question_type == 4
                  "
                  class="score-input-container ml-3"
                >
                  <div class="mr-1">
                    <strong
                      >{{ $t("evaluations.newEvaluations.scoreObtained") }}:
                    </strong>
                    {{
                      evaluatee_question_score.automated_score != null
                        ? evaluatee_question_score.automated_score
                        : 0
                    }}
                  </div>
                </div>
                <div class="score-input-container ml-3">
                  <div class="mr-1">
                    <strong
                      >{{
                        $t("evaluations.newEvaluations.scoreObtained")
                      }}:</strong
                    >
                  </div>
                  <div class="d-flex align-items-center">
                    <b-form-input
                      :class="{
                        'border-warning text-warning':
                          evaluatee_question_score.manual_score >
                          Question.max_score,
                        'border-danger text-danger':
                          evaluatee_question_score.manual_score < 0,
                      }"
                      :id="`tooltip-target-manual_score-${Question.id}-${
                        Question.order
                      }-${testSegment ? testSegment.order : ''}`"
                      class="mr-3"
                      style="max-width: 80px"
                      v-model="evaluatee_question_score.manual_score"
                      :disabled="!closedEvaluationScore"
                      @input="patchEvaluateeScore"
                      type="number"
                      min="0"
                    ></b-form-input>
                    <b-tooltip
                      :target="`tooltip-target-manual_score-${Question.id}-${
                        Question.order
                      }-${testSegment ? testSegment.order : ''}`"
                      v-if="evaluatee_question_score.manual_score < 0"
                      variant="danger"
                      triggers="hover"
                    >
                      {{
                        $t(
                          "evaluations.newEvaluations.scoreCannotBeLessThanZero"
                        )
                      }}
                    </b-tooltip>
                    <b-tooltip
                      :target="`tooltip-target-manual_score-${Question.id}-${
                        Question.order
                      }-${testSegment ? testSegment.order : ''}`"
                      v-else-if="
                        evaluatee_question_score.manual_score >
                        Question.max_score
                      "
                      variant="warning"
                      triggers="hover"
                    >
                      {{
                        $t(
                          "evaluations.newEvaluations.assignedScoreGreaterThanQuestion"
                        )
                      }}
                    </b-tooltip>
                  </div>
                </div>
                <div class="score-input-container ml-1 mr-1">
                  <b-button
                    v-if="
                      evaluator_view &&
                      closedEvaluationScore &&
                      (evaluatee_question_score.feedback == null ||
                        evaluatee_question_score.feedback.trim().length == 0)
                    "
                    variant="primary"
                    size="sm"
                    class="lock-btn p-0 mr-1"
                    v-b-tooltip.top.noninteractive.v-secondary="
                      $t('evaluations.newEvaluations.addFeedback')
                    "
                    tabindex="-1"
                    @click="showModalQuestionFeedback()"
                  >
                    <b-icon icon="chat-left-text-fill"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <!-- Puntaje Obtenido vista del Estudiante -->
            <!-- <template v-if="evaluatee_view">
              <div class="d-flex mr-2">
                <span>
                  <strong>Puntaje Obtenido:</strong>
                </span>
                <span class="ml-1">
                  {{ evaluatee_question_score.manual_score }}
                </span>
              </div>
            </template> -->
            <template
              v-if="
                !evaluator_view &&
                !evaluatee_view &&
                allows_crud &&
                !Question.is_locked &&
                [1].includes(Question.question_type) &&
                Question.proposed_answer.trim().length == 0
              "
            >
              <div class="d-flex noprint">
                <div class="score-input-container ml-3 mr-1">
                  <ButtonMedium
                    tabindex="-1"
                    :tooltip_text="
                      $t('evaluations.newEvaluations.addCorrectAnswer')
                    "
                    :text_button="``"
                    :click_button="showModalProposedAnswerQuestion"
                    :icon="'file-check'"
                    :variant="'primary'"
                    :custom_class="`mr-1`"
                  >
                  </ButtonMedium>
                </div>
              </div>
            </template>
            <template
              v-if="
                !evaluator_view &&
                !evaluatee_view &&
                allows_crud &&
                !Question.is_locked &&
                [2].includes(Question.question_type)
              "
            >
              <div class="d-flex noprint">
                <div
                  class="score-input-container ml-3"
                  v-if="Question.correct_alternative_message.trim().length == 0"
                >
                  <ButtonMedium
                    tabindex="-1"
                    :tooltip_text="
                      $t('evaluations.newEvaluations.addCorrectAnswer')
                    "
                    :text_button="``"
                    :click_button="showModalCorrectMessageQuestion"
                    :icon="'file-check'"
                    :variant="'primary'"
                    :custom_class="`mr-1`"
                  >
                  </ButtonMedium>
                </div>
                <div
                  class="score-input-container mr-1"
                  v-if="
                    Question.incorrect_alternative_message.trim().length == 0
                  "
                >
                  <ButtonMedium
                    tabindex="-1"
                    :tooltip_text="
                      $t('evaluations.newEvaluations.addIncorrectAnswer')
                    "
                    :text_button="``"
                    :click_button="showModalIncorrectMessageQuestion"
                    :icon="'file-x'"
                    :variant="'primary'"
                    :custom_class="`mr-1`"
                  >
                  </ButtonMedium>
                </div>
              </div>
            </template>
          </div>
          <div
            v-if="
              (!evaluator_view &&
                !evaluatee_view &&
                allows_crud &&
                [1].includes(Question.question_type) &&
                Question.proposed_answer.trim().length != 0) ||
              (evaluator_view &&
                !evaluatee_view &&
                [1].includes(Question.question_type) &&
                Question.proposed_answer.trim().length != 0)
            "
            class="noprint"
          >
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <div class="d-flex">
                    <b-button
                      block
                      v-b-toggle="
                        `collapse-${Question.test}-${Question.question_type}-${Question.id}`
                      "
                      tabindex="-1"
                      variant="info"
                      >{{
                        $t("evaluations.newEvaluations.correctAnswer")
                      }}</b-button
                    >
                    <b-button
                      v-if="!evaluator_view && !evaluatee_view"
                      class="ml-1 p-1"
                      variant="danger"
                      v-b-tooltip.top.noninteractive.v-secondary="
                        $t('evaluations.newEvaluations.clearCorrectAnswer')
                      "
                      @click="clearCorrectAnswer"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button>
                  </div>
                </b-card-header>
                <b-collapse
                  :id="`collapse-${Question.test}-${Question.question_type}-${Question.id}`"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body class="p-0">
                    <b-card-text>
                      <div
                        class="w-100 pl-2 pr-2 pt-2 pb-3"
                        :class="{
                          'title-container': allows_crud && !Question.is_locked,
                        }"
                        @click="showModalProposedAnswerQuestion()"
                      >
                        <RenderVHtml
                          v-b-tooltip.top.noninteractive.v-secondary="
                            `${
                              allows_crud && !Question.is_locked
                                ? $t(
                                    'evaluations.newEvaluations.editCorrectAnswer'
                                  )
                                : ''
                            }`
                          "
                          :content="Question.proposed_answer"
                        ></RenderVHtml>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div
            v-if="
              [2].includes(Question.question_type) &&
              Question.correct_alternative_message.trim().length != 0 &&
              ((!evaluator_view && !evaluatee_view && allows_crud) ||
                (evaluator_view && !evaluatee_view) ||
                (evaluatee_view && is_published && finished_test))
            "
            class="noprint"
          >
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <div class="d-flex">
                    <b-button
                      block
                      v-b-toggle="
                        `collapse-correct_alternative_message-${Question.test}-${Question.question_type}-${Question.id}`
                      "
                      tabindex="-1"
                      variant="info"
                      >{{
                        $t("evaluations.newEvaluations.correctAnswer")
                      }}</b-button
                    >
                    <b-button
                      v-if="!evaluator_view && !evaluatee_view"
                      class="ml-1 p-1"
                      variant="danger"
                      v-b-tooltip.top.noninteractive.v-secondary="
                        $t('evaluations.newEvaluations.clearCorrectAnswer')
                      "
                      @click="clearCorrectMessage"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button>
                  </div>
                </b-card-header>
                <b-collapse
                  :id="`collapse-correct_alternative_message-${Question.test}-${Question.question_type}-${Question.id}`"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body class="p-0">
                    <b-card-text>
                      <div
                        class="w-100 pl-2 pr-2 pt-2 pb-3"
                        :class="{
                          'title-container': allows_crud && !Question.is_locked,
                        }"
                        @click="showModalCorrectMessageQuestion()"
                      >
                        <RenderVHtml
                          v-b-tooltip.top.noninteractive.v-secondary="
                            `${
                              allows_crud && !Question.is_locked
                                ? $t(
                                    'evaluations.newEvaluations.editCorrectAnswer'
                                  )
                                : ''
                            }`
                          "
                          :content="Question.correct_alternative_message"
                        ></RenderVHtml>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div
            v-if="
              [2].includes(Question.question_type) &&
              Question.incorrect_alternative_message.trim().length != 0 &&
              ((!evaluator_view && !evaluatee_view && allows_crud) ||
                (evaluator_view && !evaluatee_view) ||
                (evaluatee_view &&
                  is_published &&
                  finished_test &&
                  ((evaluatee_question_score &&
                    ((evaluatee_question_score.final_score != null &&
                      evaluation.final_score != Question.max_score) ||
                      (evaluatee_question_score.final_score == null &&
                        evaluatee_question_score.manual_score != null &&
                        evaluatee_question_score.manual_score !=
                          Question.max_score) ||
                      (evaluatee_question_score.final_score == null &&
                        evaluatee_question_score.manual_score == null &&
                        evaluatee_question_score.automated_score != null &&
                        evaluatee_question_score.automated_score !=
                          Question.max_score))) ||
                    isNaN(evaluatee_question_score))))
            "
            class="noprint"
          >
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <div class="d-flex">
                    <b-button
                      block
                      v-b-toggle="
                        `collapse-incorrect_alternative_message-${Question.test}-${Question.question_type}-${Question.id}`
                      "
                      tabindex="-1"
                      variant="info"
                      >{{
                        $t("evaluations.newEvaluations.incorrectAnswer")
                      }}</b-button
                    >
                    <b-button
                      v-if="!evaluator_view && !evaluatee_view"
                      class="ml-1 p-1"
                      variant="danger"
                      v-b-tooltip.top.noninteractive.v-secondary="
                        $t('evaluations.newEvaluations.clearIncorrectAnswer')
                      "
                      @click="clearIncorrectMessage"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button>
                  </div>
                </b-card-header>
                <b-collapse
                  :id="`collapse-incorrect_alternative_message-${Question.test}-${Question.question_type}-${Question.id}`"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body class="p-0">
                    <b-card-text>
                      <div
                        class="w-100 pl-2 pr-2 pt-2 pb-3"
                        :class="{
                          'title-container': allows_crud && !Question.is_locked,
                        }"
                        @click="showModalIncorrectMessageQuestion()"
                      >
                        <RenderVHtml
                          v-b-tooltip.top.noninteractive.v-secondary="
                            `${
                              allows_crud && !Question.is_locked
                                ? $t(
                                    'evaluations.newEvaluations.editIncorrectAnswer'
                                  )
                                : ''
                            }`
                          "
                          :content="Question.incorrect_alternative_message"
                        ></RenderVHtml>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <!-- feedback -->
          <div
            v-if="
              (evaluator_view &&
                evaluatee_question_score.feedback != null &&
                evaluatee_question_score.feedback.trim().length != 0) ||
              (!evaluator_view &&
                evaluatee_view &&
                is_published &&
                finished_test &&
                evaluatee_question_score.feedback != null &&
                evaluatee_question_score.feedback.trim().length != 0)
            "
            class="noprint"
          >
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <div class="d-flex">
                    <b-button
                      block
                      v-b-toggle="
                        `collapse-feedback-${Question.test}-${Question.question_type}-${Question.id}`
                      "
                      tabindex="-1"
                      variant="info"
                      >{{ $t("evaluations.newEvaluations.feedback") }}</b-button
                    >
                    <b-button
                      v-if="!evaluatee_view && closedEvaluationScore"
                      class="ml-1 p-1"
                      variant="danger"
                      v-b-tooltip.top.noninteractive.v-secondary="
                        $t('evaluations.newEvaluations.clearFeedback')
                      "
                      @click="clearFeedbackTeacher"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button>
                  </div>
                </b-card-header>
                <b-collapse
                  :id="`collapse-feedback-${Question.test}-${Question.question_type}-${Question.id}`"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body class="p-0">
                    <b-card-text>
                      <div
                        v-if="!evaluatee_view && closedEvaluationScore"
                        class="title-container w-100 pl-2 pr-2 pt-2 pb-3"
                        @click="showModalQuestionFeedback()"
                      >
                        <RenderVHtml
                          v-b-tooltip.top.noninteractive.v-secondary="
                            `${
                              allows_crud && !Question.is_locked
                                ? $t(
                                    'evaluations.newEvaluations.editCorrectAnswer'
                                  )
                                : ''
                            }`
                          "
                          :content="evaluatee_question_score.feedback"
                        ></RenderVHtml>
                      </div>
                      <div
                        v-else-if="!evaluatee_view && !closedEvaluationScore"
                        class="w-100 pl-2 pr-2 pt-2 pb-3"
                      >
                        <RenderVHtml
                          :content="evaluatee_question_score.feedback"
                        ></RenderVHtml>
                      </div>
                      <div
                        v-if="
                          evaluatee_view &&
                          is_published &&
                          finished_test &&
                          evaluatee_question_score.feedback != null &&
                          evaluatee_question_score.feedback.trim().length != 0
                        "
                        class="p-1 pl-2"
                      >
                        <RenderVHtml
                          :content="evaluatee_question_score.feedback"
                        ></RenderVHtml>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContainerRichTextKlv3
      :id_modal="`edit-title-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title_modal="
        $t('reusable.common.editTooltip', {
          entity: $getVisibleNames('manual.test.enunciado', false, 'Enunciado'),
        })
      "
      :size_modal="`lg`"
      :object_rich_text="Question"
      :content_rich_text="Question.title"
      :permit_blank="false"
      :show_last_modification="true"
      @save="(content) => patchQuestionTitle(Question, content)"
      @close="
        $bvModal.hide(
          `edit-title-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
        )
      "
    >
    </ContainerRichTextKlv3>
    <ContainerRichTextKlv3
      :id_modal="`edit-description-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title_modal="$t('evaluations.newEvaluations.modifyDescription')"
      :size_modal="`lg`"
      :object_rich_text="Question"
      :content_rich_text="Question.description"
      :show_last_modification="true"
      @save="(content) => patchQuestionDescription(Question, content)"
      @close="
        $bvModal.hide(
          `edit-description-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
        )
      "
    >
    </ContainerRichTextKlv3>
    <ContainerRichTextKlv3
      :id_modal="`edit-proposed_answer-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title_modal="$t('evaluations.newEvaluations.modifyCorrectAnswer')"
      :size_modal="`lg`"
      :object_rich_text="Question"
      :content_rich_text="Question.proposed_answer"
      :show_last_modification="true"
      @save="(content) => patchQuestionProposedAnswer(Question, content)"
      @close="
        $bvModal.hide(
          `edit-proposed_answer-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
        )
      "
    >
    </ContainerRichTextKlv3>
    <ContainerRichTextKlv3
      :id_modal="`edit-correct_alternative_message-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title_modal="$t('evaluations.newEvaluations.modifyCorrectAnswer')"
      :size_modal="`lg`"
      :object_rich_text="Question"
      :content_rich_text="Question.correct_alternative_message"
      :show_last_modification="true"
      @save="(content) => patchQuestionCorrectMessage(Question, content)"
      @close="
        $bvModal.hide(
          `edit-correct_alternative_message-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
        )
      "
    >
    </ContainerRichTextKlv3>
    <ContainerRichTextKlv3
      :id_modal="`edit-incorrect_alternative_message-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title_modal="$t('evaluations.newEvaluations.modifyIncorrectAnswer')"
      :size_modal="`lg`"
      :object_rich_text="Question"
      :content_rich_text="Question.incorrect_alternative_message"
      :show_last_modification="true"
      @save="(content) => patchQuestionIncorrectMessage(Question, content)"
      @close="
        $bvModal.hide(
          `edit-incorrect_alternative_message-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
        )
      "
    >
    </ContainerRichTextKlv3>
    <ContainerRichTextKlv3
      :id_modal="`edit-feedback-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title_modal="$t('evaluations.newEvaluations.modifyFeedback')"
      :size_modal="`lg`"
      :object_rich_text="evaluatee_question_score"
      :content_rich_text="evaluatee_question_score.feedback"
      :show_last_modification="true"
      @save="
        (content) => patchFeedbackQuestion(evaluatee_question_score, content)
      "
      @close="
        $bvModal.hide(
          `edit-feedback-question-modal-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
        )
      "
    >
    </ContainerRichTextKlv3>
    <b-modal
      :id="`modal-edit-question-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`"
      :title="
        $t('reusable.common.editTooltip', {
          entity: $getVisibleNames(
            'evaluations2.redactionquestion',
            false,
            'Pregunta'
          ),
        })
      "
      hide-footer
      size="lg"
      ignore-enforce-focus-selector="#sidebar-right"
      @hide="hideModalQuestion"
    >
      <NewQuestionForm
        :test_id="Question.test"
        :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
        :Question="Question"
        :evaluation_situations="evaluation_situations"
        @closeModal="
          $bvModal.hide(
            `modal-edit-question-${Question.test}-${Question.question_type}-${Question.id}-${container_instrument_id}`
          )
        "
      ></NewQuestionForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { generateUniqueId, toast } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "NewQuestionCard",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RubricsContainer: () =>
      import("@/components/new-evaluations/Rubrics/RubricsContainer"),
    NewQuestionForm: () =>
      import(
        "@/components/new-evaluations/Evaluation/Questions/NewQuestionForm"
      ),
    LimitQuestion: () =>
      import("@/components/new-evaluations/Evaluation/Questions/LimitQuestion"),
    SelectQuestionOptions: () =>
      import(
        "@/components/new-evaluations/Evaluation/Questions/SelectQuestionOptions"
      ),
    FillingQuestion: () =>
      import(
        "@/components/new-evaluations/Evaluation/Questions/FillingQuestion"
      ),
    MatchingQuestion: () =>
      import(
        "@/components/new-evaluations/Evaluation/Questions/MatchingQuestion/MatchingQuestion"
      ),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    InfoPopover: () => import("@/components/reusable/InfoPopover"),
  },
  props: {
    Question: {
      type: Object,
      required: true,
    },
    // Orden del segmento tal como se muestra (aleatorio para el estudiante).
    segment_order: {
      type: Number,
      default: null,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    preview_evaluation: {
      type: Boolean,
      required: true,
    },
    evaluation_criteria_micro_ids: {
      type: Array,
      required: true,
    },
    checked_score: {
      type: Boolean,
    },
    checked_weightning: {
      type: Boolean,
    },
    container_instrument_id: {
      type: String,
    },
    evaluatee_view: {
      type: Boolean,
      default: false,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
    is_running_test: {
      type: Boolean,
      default: false,
    },
    finished_test: {
      type: Boolean,
      default: false,
    },
    evaluation_situations: {
      type: Array,
    },
    // para mostrar el resultado del evaluado al profesor.
    user_id: {
      type: Number,
      required: false,
    },
    // para restringir que el evaluador pueda colocar notas fuera del periodo actual con respecto al de la sección.
    closedEvaluationScore: {
      type: Boolean,
      default: false,
    },
    is_published: {
      type: Boolean,
    },
  },
  data() {
    return {
      question_types: [
        { id: 1, value: "Desarrollo" },
        { id: 2, value: "Selección" },
        // { id: 3, value: "Auto Completar" },
        { id: 4, value: "Emparejamiento" },
      ],
      // limited_words_amount: false,
      evaluatee_question_score: {
        id: generateUniqueId(),
        automated_score: null,
        manual_score: null,
        final_score: null,
        evaluatee: this.user_id,
        feedback: "",
        attachments: [],
      },
      copy_button_tem_check: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      test_segments: names.NEW_TEST_SEGMENTS,
      max_answer_length_types: names.REDACTION_QUESTION_LENGTH_ANSWERS,
      evaluations: names.NEW_EVALUATIONS,
      evaluatee_evaluations: names.EVALUATEE_EVALUATIONS,
      tests: names.NEW_TESTS,
      redaction_questions: names.NEW_REDACTION_QUESTIONS,
      evaluatee_redaction_questions: names.EVALUATEE_REDACTION_QUESTIONS,
      evaluatee_multiple_choice_questions:
        names.EVALUATEE_MULTIPLE_CHOICE_QUESTIONS,
      evaluatee_matching_questions: names.EVALUATEE_MATCHING_QUESTIONS,
      multiple_choice_questions: names.NEW_MULTIPLE_CHOICE_QUESTIONS,
      filling_questions: names.NEW_FILLING_QUESTIONS,
      matching_questions: names.NEW_MATCHING_QUESTIONS,
      rubrics_criterias: names.NEW_RUBRIC_CRITERIAS,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      sections: names.SECTIONS,
      evaluatee_multiple_choice_question_options:
        names.EVALUATEE_MULTIPLE_CHOICE_QUESTION_OPTIONS,
      evaluatee_matching_question_units:
        names.EVALUATEE_MATCHING_QUESTION_UNITS,
      evaluation_criteria_micros: names.EVALUATION_CRITERIAS,
    }),
    test() {
      return this.tests.find((x) => x.id == this.Question.test);
    },
    evaluation() {
      if (!this.test) return null;
      return this.evaluations.find((x) => x.id == this.test.evaluation);
    },
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections.find((x) => x.id == this.evaluation.scope_id);
      else return null;
    },
    egressProfileMatter() {
      if (
        this.evaluation &&
        this.evaluation.scope == 2 &&
        this.evaluation.scope_id != null
      ) {
        return this.egress_profile_matters.find(
          (x) => x.id == this.evaluation.scope_id
        );
      }
      if (
        this.evaluation &&
        this.evaluation.scope == 1 &&
        this.section &&
        this.section.egress_profile_matter != null
      ) {
        return this.egress_profile_matters.find(
          (x) => x.id == this.section.egress_profile_matter
        );
      }
      return null;
    },
    evalutionCriteriaMicro() {
      if (
        !this.Question ||
        !this.Question.evaluation_criterias_micro ||
        this.Question.evaluation_criterias_micro.length == 0
      ) {
        return [];
      }
      return this.Question.evaluation_criterias_micro.map((id) => {
        return this.evaluation_criteria_micros.find((x) => x.id == id);
      });
    },
    evaluateeEvaluationScore() {
      if (!this.test) return null;
      return this.evaluatee_evaluations.find(
        (x) =>
          x.evaluation == this.test.evaluation && x.evaluatee == this.user_id
      );
    },
    evaluationSituation() {
      if (!this.test) return null;
      return this.evaluation_situations.find(
        (x) => x.id == this.test.evaluation_situation
      );
    },
    enable_question_types() {
      if (!this.evaluationSituation) return [1, 2, 4];
      else {
        let question_enable = [];
        if (this.evaluationSituation.enable_redaction_questions)
          question_enable.push(1);
        if (
          this.evaluationSituation.enable_simple_selection_questions ||
          this.evaluationSituation.enable_multiple_selection_questions
        )
          question_enable.push(2);
        if (this.evaluationSituation.enable_matching_questions)
          question_enable.push(4);
        return question_enable;
      }
    },
    evaluateeMultipleChoiceQuestionOptions() {
      if (this.EvaluateeQuestionScore && isNaN(this.EvaluateeQuestionScore.id))
        return [];
      else if (this.EvaluateeQuestionScore) {
        return this.evaluatee_multiple_choice_question_options.filter(
          (x) =>
            x.evaluatee_multiple_choice_question ==
            this.EvaluateeQuestionScore.id
        );
      }
      return [];
    },
    EvaluateeQuestionUnitScores() {
      if (this.EvaluateeQuestionScore == null) return [];
      else if (this.EvaluateeQuestionScore) {
        return this.evaluatee_matching_question_units.filter(
          (x) => x.evaluatee_matching_question == this.EvaluateeQuestionScore.id
        );
      }
      return [];
    },
    enable_question_sub_types() {
      if (!this.evaluationSituation) return [1, 2];
      else {
        let question_sub_types_enable = [];
        if (this.evaluationSituation.enable_simple_selection_questions)
          question_sub_types_enable.push(1);
        if (this.evaluationSituation.enable_multiple_selection_questions)
          question_sub_types_enable.push(2);
        return question_sub_types_enable;
      }
    },
    questionsMaxScore() {
      let score = 0;
      this.questions.forEach((element) => {
        if (
          element.id == this.Question.id &&
          element.question_type == this.Question.question_type
        ) {
          if (this.Question.max_score != "" && this.Question.max_score != null)
            score += parseFloat(this.Question.max_score);
        } else score += parseFloat(element.max_score);
      });
      return score;
    },
    EvaluateeQuestionScore() {
      if (this.Question.question_type == 1)
        return this.evaluatee_redaction_questions.find(
          (x) =>
            x.evaluatee == this.user_id &&
            x.redaction_question == this.Question.id
        );
      else if (this.Question.question_type == 2)
        return this.evaluatee_multiple_choice_questions.find(
          (x) =>
            x.evaluatee == this.user_id &&
            x.multiple_choice_question == this.Question.id
        );
      else if (this.Question.question_type == 4)
        return this.evaluatee_matching_questions.find(
          (x) =>
            x.evaluatee == this.user_id &&
            x.matching_question == this.Question.id
        );
      else return null;
    },
    questions() {
      let list = [];
      list = list.concat(
        this.redactionQuestions.map((question) => ({
          ...question,
          question_type: 1,
        }))
      );
      list = list.concat(
        this.multipleChoiceQuestions.map((question) => ({
          ...question,
          question_type: 2,
        }))
      );
      // list = list.concat(
      //   this.fillingQuestions.map((question) => ({
      //     ...question,
      //     question_type: 3,
      //   }))
      // );
      list = list.concat(
        this.matchingQuestions.map((question) => ({
          ...question,
          question_type: 4,
        }))
      );
      return list.sort((a, b) => a.order - b.order);
    },
    redactionQuestions() {
      return this.redaction_questions.filter(
        (x) => x.test == this.Question.test
      );
    },
    multipleChoiceQuestions() {
      return this.multiple_choice_questions.filter(
        (x) => x.test == this.Question.test
      );
    },
    fillingQuestions() {
      return this.filling_questions.filter((x) => x.test == this.Question.test);
    },
    matchingQuestions() {
      return this.matching_questions.filter(
        (x) => x.test == this.Question.test
      );
    },
    // maxAnswerLengthType() {
    //   let max_answer_length_types = [...this.max_answer_length_types];
    //   max_answer_length_types.push({ id: null, value: "N/A" });
    //   return max_answer_length_types;
    // },
    questionsWeighing() {
      let maxScore = 0;
      if (this.test) maxScore = this.test.max_score;
      if (maxScore == 0) return 0;
      return parseFloat(
        ((parseFloat(this.Question.max_score) / maxScore) * 100).toFixed(2)
      );
    },
    rubricsCriteria() {
      if (this.Question.linked_rubric_criteria == null) return null;
      return this.rubrics_criterias.find(
        (x) => x.id == this.Question.linked_rubric_criteria
      );
    },
    questionsWeighingRubricCriteria() {
      const questions_weighing = this.questionsWeighing;
      if (!this.rubricsCriteria || !this.test) return questions_weighing;
      const rubrics_criteria = this.rubricsCriteria;
      let questions_criteria = this.questions.filter(
        (x) => x.linked_rubric_criteria == rubrics_criteria.id
      );
      if (questions_criteria.length == 0) return questions_weighing;
      else {
        const questions_scores = questions_criteria.reduce(
          (acc, a) => acc + parseFloat(a.max_score),
          0
        );
        return parseFloat(
          ((questions_scores / this.test.max_score) * 100).toFixed(2)
        );
      }
    },
    suggestedScore() {
      if (
        this.Question.linked_rubric_criteria != null &&
        this.rubricsCriteria
      ) {
        const correct_weighing = this.questionsWeighingRubricCriteria;
        const rubrics_criteria_weighing = this.rubricsCriteria.weighing;
        let max_score = 0;
        if (this.test) max_score = this.test.max_score;
        if (max_score == 0) return this.Question.max_score;
        return parseFloat(
          (
            ((rubrics_criteria_weighing - correct_weighing) * max_score) /
            100
          ).toFixed(2)
        );
      } else return parseFloat(this.Question.max_score);
    },
    testSegment() {
      if (this.Question.segment == null) return null;
      return this.test_segments.find((x) => x.id == this.Question.segment);
    },
    displayedSegmentOrder() {
      if (this.segment_order != null) return this.segment_order;
      return this.testSegment ? this.testSegment.order : null;
    },
  },
  methods: {
    insertStoreOpenAiQuestion() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [8],
        disabled_selected_intelligence_option: true,
      });
    },
    openModalQuestion() {
      this.insertStoreOpenAiQuestion();
      if (
        this.evaluation &&
        this.evaluation.scope == 3 &&
        this.evaluation.scope_id != null
      ) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.evaluation.scope_id,
            available_evaluation_criteria_micro:
              this.evaluation_criteria_micro_ids,
            extra_label: this.$t("evaluations.newEvaluations.question"),
            extra_context: this.$t(
              "evaluations.newEvaluations.forTheEvaluation"
            ),
            intelligence_option: 8,
            sub_option: 3,
            show_message_evaluation_view: true,
          });
        });
      }
      if (
        this.egressProfileMatter &&
        this.evaluation &&
        (this.evaluation.scope == 2 || this.evaluation.scope == 1) &&
        this.evaluation.scope_id != null
      ) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.egressProfileMatter.matter,
            available_evaluation_criteria_micro:
              this.evaluation_criteria_micro_ids,
            extra_label: this.$t("evaluations.newEvaluations.question"),
            extra_context: this.$t(
              "evaluations.newEvaluations.forTheEvaluation"
            ),
            intelligence_option: 8,
            sub_option: 3,
            show_message_evaluation_view: true,
          });
        });
      }
      this.$bvModal.show(
        `modal-edit-question-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
      );
    },
    hideModalQuestion() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [7],
      });

      if (
        this.evaluation &&
        this.evaluation.scope == 3 &&
        this.evaluation.scope_id != null
      ) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.evaluation.scope_id,
            extra_context: this.$t(
              "evaluations.newEvaluations.forTheEvaluation"
            ),
            extra_label: "",
            show_message_evaluation_view: true,
            intelligence_option: 7,
          });
        });
      }
      if (
        this.egressProfileMatter &&
        this.evaluation &&
        (this.evaluation.scope == 2 || this.evaluation.scope == 1) &&
        this.evaluation.scope_id != null
      ) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.egressProfileMatter.matter,
            extra_context: this.$t(
              "evaluations.newEvaluations.forTheEvaluation"
            ),
            show_message_evaluation_view: true,
            intelligence_option: 7,
          });
        });
      }
    },
    copyQuestion() {
      this.copy_button_tem_check = true;
      if (this.Question.question_type == 1) {
        this.$restful
          .Get(
            `/evaluations2/copy_redaction_question_in_test/?redaction_question=${this.Question.id}&test=${this.Question.test}`
          )
          .then((question_id) => {
            this.$store
              .dispatch(names.FETCH_NEW_REDACTION_QUESTION, question_id)
              .then(() => {
                this.copy_button_tem_check = false;
                toast(this.$t("evaluations.newEvaluations.questionCopied"));
              });
          });
      } else if (this.Question.question_type == 2) {
        this.$restful
          .Get(
            `/evaluations2/copy_multiple_choice_question_in_test/?multiple_choice_question=${this.Question.id}&test=${this.Question.test}`
          )
          .then((question_id) => {
            this.$store
              .dispatch(names.FETCH_NEW_MULTIPLE_CHOICE_QUESTION, question_id)
              .then(() => {
                this.copy_button_tem_check = false;
                toast(this.$t("evaluations.newEvaluations.questionCopied"));
              });
          });
      } else if (this.Question.question_type == 4) {
        this.$restful
          .Get(
            `/evaluations2/copy_matching_question_in_test/?matching_question=${this.Question.id}&test=${this.Question.test}`
          )
          .then((question_id) => {
            this.$store
              .dispatch(names.FETCH_NEW_MATCHING_QUESTION, question_id)
              .then(() => {
                this.copy_button_tem_check = false;
                toast(this.$t("evaluations.newEvaluations.questionCopied"));
              });
          });
      }
    },
    changeStateQuestion() {
      this.patchQuestion({ is_locked: !this.Question.is_locked });
    },
    askForDeleteQuestion() {
      this.$swal({
        title: `<p>${this.$t(
          "evaluations.newEvaluations.sureToDeleteQuestion"
        )}</p>`,
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.Question.question_type == 1) {
            this.$store.dispatch(
              names.DELETE_NEW_REDACTION_QUESTION,
              this.Question.id
            );
          } else if (this.Question.question_type == 2) {
            this.$store.dispatch(
              names.DELETE_NEW_MULTIPLE_CHOICE_QUESTION,
              this.Question.id
            );
          } else if (this.Question.question_type == 3) {
            this.$store.dispatch(
              names.DELETE_NEW_FILLING_QUESTION,
              this.Question.id
            );
          } else if (this.Question.question_type == 4) {
            this.$store.dispatch(
              names.DELETE_NEW_MATCHING_QUESTION,
              this.Question.id
            );
          }
          toast(this.$t("evaluations.newEvaluations.questionDeleted"));
        }
      });
    },
    patchQuestion(item) {
      if (this.Question.question_type == 1) {
        const payload = {
          new_redaction_question_id: this.Question.id,
          item: item,
        };
        this.$store.dispatch(names.PATCH_NEW_REDACTION_QUESTION, payload);
      } else if (this.Question.question_type == 2) {
        const payload = {
          new_multiple_choice_question_id: this.Question.id,
          item: item,
        };
        this.$store.dispatch(names.PATCH_NEW_MULTIPLE_CHOICE_QUESTION, payload);
      } else if (this.Question.question_type == 3) {
        const payload = {
          new_filling_question_id: this.Question.id,
          item: item,
        };
        this.$store.dispatch(names.PATCH_NEW_FILLING_QUESTION, payload);
      } else if (this.Question.question_type == 4) {
        const payload = {
          new_matching_question_id: this.Question.id,
          item: item,
        };
        this.$store.dispatch(names.PATCH_NEW_MATCHING_QUESTION, payload);
      }
      toast(this.$t("evaluations.newEvaluations.questionUpdated"));
    },
    questionTypes() {
      const questionType = this.question_types.find(
        (x) => x.id == this.Question.question_type
      );
      if (questionType) return questionType.value;
      else return "";
    },
    patchQuestionScore(value) {
      if (value >= 0 && value != null && value != "") {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.patchQuestion({ max_score: value });
        }, 1000);
      }
    },
    showModalQuestion() {
      if (this.allows_crud && !this.Question.is_locked)
        this.$bvModal.show(
          `edit-title-question-modal-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
        );
    },
    showModalDescriptionQuestion() {
      if (this.allows_crud && !this.Question.is_locked)
        this.$bvModal.show(
          `edit-description-question-modal-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
        );
    },
    showModalProposedAnswerQuestion() {
      if (this.allows_crud && !this.Question.is_locked)
        this.$bvModal.show(
          `edit-proposed_answer-question-modal-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
        );
    },
    showModalCorrectMessageQuestion() {
      if (this.allows_crud && !this.Question.is_locked && !this.evaluatee_view)
        this.$bvModal.show(
          `edit-correct_alternative_message-question-modal-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
        );
    },
    showModalIncorrectMessageQuestion() {
      if (this.allows_crud && !this.Question.is_locked && !this.evaluatee_view)
        this.$bvModal.show(
          `edit-incorrect_alternative_message-question-modal-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
        );
    },
    showModalQuestionFeedback() {
      this.$bvModal.show(
        `edit-feedback-question-modal-${this.Question.test}-${this.Question.question_type}-${this.Question.id}-${this.container_instrument_id}`
      );
    },
    patchQuestionTitle(question, text) {
      this.patchQuestion({ title: text });
    },
    patchQuestionDescription(question, text) {
      this.patchQuestion({ description: text });
    },
    patchQuestionProposedAnswer(question, text) {
      this.patchQuestion({ proposed_answer: text });
    },
    patchQuestionCorrectMessage(question, text) {
      this.patchQuestion({ correct_alternative_message: text });
    },
    patchQuestionIncorrectMessage(question, text) {
      this.patchQuestion({ incorrect_alternative_message: text });
    },
    patchFeedbackQuestion(question, text) {
      this.patchEvaluateeQuestion({ feedback: text });
    },
    clearFeedbackTeacher() {
      this.patchEvaluateeQuestion({ feedback: "" });
    },
    clearCorrectAnswer() {
      this.patchQuestion({ proposed_answer: "" });
    },
    clearCorrectMessage() {
      this.patchQuestion({ correct_alternative_message: "" });
    },
    clearIncorrectMessage() {
      this.patchQuestion({ incorrect_alternative_message: "" });
    },
    changeEvaluateeTest() {
      if (this.user_id && this.test) {
        this.$store.dispatch(names.FETCH_EVALUATEE_TESTS, {
          evaluatee_id: this.user_id,
          test_id: this.instrument_id,
        });
        this.$store.dispatch(names.FETCH_EVALUATEE_EVALUATIONS, {
          evaluatee_id: this.user_id,
          evaluation_id: this.test.evaluation,
        });
      }
    },
    patchEvaluateeScore(value) {
      if (this.closedEvaluationScore)
        if (value >= 0 && value != null && value != "") {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            if (value >= 0 && value != null && value != "") {
              if (
                this.evaluateeEvaluationScore &&
                this.test &&
                this.test.weighing > 0 &&
                (this.evaluateeEvaluationScore.final_grade != null ||
                  this.evaluateeEvaluationScore.manual_grade != null)
              ) {
                this.$swal({
                  title: this.$t(
                    "evaluations.newEvaluations.sureChangeQuestionScore"
                  ),
                  html: this.$t(
                    "evaluations.newEvaluations.changeScoreWhenGradeFixed"
                  ),
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonText: this.$t(
                    "evaluations.newEvaluations.imSure"
                  ),
                  cancelButtonText: this.$t(
                    "evaluations.newEvaluations.keepAssignedGrade"
                  ),
                }).then((result) => {
                  if (result.value) {
                    const payload = {
                      evaluatee_evaluation_id: this.evaluateeEvaluationScore.id,
                      item: {
                        manual_grade: null,
                        final_grade_grade: null,
                      },
                    };
                    this.$store
                      .dispatch(names.PATCH_EVALUATEE_EVALUATION, payload)
                      .then(() => {
                        this.patchEvaluateeQuestion({ manual_score: value });
                      });
                  } else {
                    this.patchEvaluateeQuestion({ manual_score: value });
                  }
                });
              } else {
                this.patchEvaluateeQuestion({ manual_score: value });
              }
            }
          }, 1000);
        }
    },
    patchEvaluateeQuestion(item) {
      if (
        !isNaN(this.evaluatee_question_score.id) ||
        this.EvaluateeQuestionScore != null
      ) {
        if (this.Question.question_type == 1) {
          const payload = {
            evaluatee_redaction_question_id: this.EvaluateeQuestionScore.id,
            item: item,
          };
          this.$store
            .dispatch(names.PATCH_EVALUATEE_REDACTION_QUESTION, payload)
            .then(() => {
              this.changeEvaluateeTest();
            });
        } else if (this.Question.question_type == 2) {
          const payload = {
            evaluatee_multiple_choice_question_id:
              this.EvaluateeQuestionScore.id,
            item: item,
          };
          this.$store
            .dispatch(names.PATCH_EVALUATEE_MULTIPLE_CHOICE_QUESTION, payload)
            .then(() => {
              this.changeEvaluateeTest();
            });
        } else if (this.Question.question_type == 4) {
          const payload = {
            evaluatee_matching_question_id: this.EvaluateeQuestionScore.id,
            item: item,
          };
          this.$store
            .dispatch(names.PATCH_EVALUATEE_MATCHING_QUESTION, payload)
            .then(() => {
              this.changeEvaluateeTest();
            });
        }
      } else if (isNaN(this.evaluatee_question_score.id)) {
        if (this.Question.question_type == 1) {
          this.$store
            .dispatch(names.POST_EVALUATEE_REDACTION_QUESTION, {
              automated_score: null,
              manual_score: item.manual_score ? item.manual_score : null,
              final_score: null,
              answer: "",
              feedback: item.feedback ? item.feedback : "",
              evaluatee: this.user_id,
              redaction_question: this.Question.id,
              chosen_rubric: null,
              attachments: [],
            })
            .then((response) => {
              this.evaluatee_question_score = response;
              this.changeEvaluateeTest();
            });
        } else if (this.Question.question_type == 2) {
          this.$store
            .dispatch(names.POST_EVALUATEE_MULTIPLE_CHOICE_QUESTION, {
              automated_score: null,
              manual_score: item.manual_score ? item.manual_score : null,
              final_score: null,
              feedback: item.feedback ? item.feedback : "",
              evaluatee: this.user_id,
              multiple_choice_question: this.Question.id,
              attachments: [],
            })
            .then((response) => {
              this.evaluatee_question_score = response;
              this.changeEvaluateeTest();
            });
        } else if (this.Question.question_type == 4) {
          this.$store
            .dispatch(names.POST_EVALUATEE_MATCHING_QUESTION, {
              automated_score: null,
              manual_score: item.manual_score ? item.manual_score : null,
              final_score: null,
              feedback: item.feedback ? item.feedback : "",
              evaluatee: this.user_id,
              matching_question: this.Question.id,
              attachments: [],
            })
            .then((response) => {
              this.evaluatee_question_score = response;
              this.changeEvaluateeTest();
            });
        }
      }
      toast(this.$t("evaluations.newEvaluations.questionUpdated"));
    },
  },
  watch: {
    EvaluateeQuestionScore() {
      this.evaluatee_question_score = this.EvaluateeQuestionScore;
      if (
        this.EvaluateeQuestionScore.automated_score != null &&
        this.EvaluateeQuestionScore.manual_score == null
      ) {
        this.evaluatee_question_score.manual_score =
          this.EvaluateeQuestionScore.automated_score;
      }
    },
  },
  mounted() {
    if (this.EvaluateeQuestionScore != null)
      this.evaluatee_question_score = this.EvaluateeQuestionScore;
  },
  created() {
    // if (
    //   this.Question.question_type == 1 &&
    //   this.Question.max_answer_length_type != null
    // )
    //   this.limited_words_amount = true;
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.icon-info-tooltip {
  width: 35.5px;
  height: 31px;
}
.score-print {
  display: none;
}
.weightning-print {
  display: none;
}
.unselectable-text {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.score-input-container {
  display: flex;
}
.score-input-warning {
  border: 1px solid #dc3545;
  color: red;
}
.score-input-warning-minor {
  border: 1px solid #dc3545;
  color: red;
}
.question-type-container {
  display: flex;
}
input {
  --bottom-border-color: var(--kl-color-accent-medium);
  max-height: 25px;
  max-width: 52px;
  border: none;
  border: 1px solid #c9c9c9;
  overflow: hidden;
  border-radius: 3px;
  text-align: center;
}
.form-control {
  padding: 0 !important;
}
input:focus {
  outline: none !important;
  border-bottom: 2px solid var(--bottom-border-color);
}
.invalid {
  border: 1px solid red;
}
.container-score {
  display: flex;
  flex-direction: column;
}
.line-score {
  border: 1px solid #c9c9c9;
}
.title-container:hover {
  background: #eee;
  cursor: pointer;
}
.description-question {
  padding-left: 1rem;
  padding-right: 1rem;
}
.description-container:hover {
  background: #eee;
  cursor: pointer;
}
.separator {
  border: 1px solid #c9c9c9;
  margin-right: 2rem;
  margin-left: 2rem;
}
.limit-words-section {
  margin-left: 1rem;
  text-align: left;
}
.container-buttons-allow-cruds {
  display: flex;
  padding: 5px;
}
.delete-btn {
  border: 1px;
  max-height: 27px;
  width: 27px;
}
.delete-btn:hover {
  background-color: #e45d6b;
}
.lock-btn {
  border: 1px;
  max-height: 27px !important;
  width: 27px !important;
  padding-bottom: 3px !important;
  padding-top: 3px !important;
}
.edit-btn:hover {
  background-color: var(--kl-primary-button-hover-color);
}
.edit-btn {
  border: 1px;
  max-height: 27px;
  width: 27px;
}
.container-content-question {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 520px;
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: avoid;
}
.container-header {
  display: flex;
  flex-direction: column;
}
.container-body {
  display: flex;
  flex-direction: column;
}
.container-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 1rem;
  padding-bottom: 1rem;
}
.container-body-card {
  display: flex;
  flex-direction: row;
}
.question-container {
  display: flex;
  border-radius: 3px;
  margin: 10px 0px 0px 0px;
  border: 1px solid #c9c9c9;
  transition: all 0.3s ease-out;
  overflow: hidden;
}
.question-body {
  background-color: white;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.row-div {
  width: 40px;
}
.max-width {
  width: 100%;
  border-radius: 5px;
}
.question-move {
  background: var(--kl-color-accent-medium);
  color: white;
  width: 35px;
  display: flex;
}
.question-move:hover {
  background-color: var(--kl-color-accent-medium);
  color: white;
}
.grabbable-cursor {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable-cursor:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.move-icon {
  margin: auto;
  cursor: grab;
}
@media print {
  .max-width-print {
    width: 100% !important;
    border-radius: 5px;
  }
  .question-container {
    border: none;
  }
}
@media (max-width: 750px) {
  label {
    max-width: 160px;
  }
  .container-footer {
    flex-direction: column;
  }
  .question-type-container {
    margin-top: 0rem;
  }
  .question-container {
    overflow-x: auto;
  }
}
</style>

